import { safeParseJSON, ajaxCall } from "./utils/misc";

declare const jQuery: any;
const $ = jQuery;

export function initLazyThumbnails(): void
{
	$(".lazy-thumbnails [data-more-id-arrays]").each(function () {
		const $btn = $(this);
		const idArrays: number[][] = safeParseJSON($btn.attr("data-more-id-arrays"));
		if (!idArrays || !idArrays.length)
		{
			return;
		}
		let offset = 0;
		const $main = $btn.closest(".lazy-thumbnails").find(".lazy-thumbnails-main ul.thumbnails");
		const ajaxData: any = safeParseJSON($btn.attr("data-ajax-meta")) || {};
		$btn.click(e => {
			if (offset >= idArrays.length || $btn.hasClass("disabled"))
			{
				return false;
			}
			$main.addClass("busy");
			$btn.addClass("disabled");
			ajaxData.ids = idArrays[offset];
			ajaxCall("iw_lazy_thumbnails_fetch", ajaxData).then((res) => {
				if (!res || !res.html)
				{
					console.error("Bad result from lazy thumbnails fetch", res);
					return;
				}
				++offset;
				if (offset >= idArrays.length)
				{
					$btn.closest(".lazy-thumbnails-more").remove();
				}
				const $thumbs = $($.trim(res.html)).filter("ul").children("li").css({ opacity: 0 });
				$main.append($thumbs);
				$thumbs.each(function (index) {
					const $item = $(this);
					setTimeout(() => {
						$item.css("opacity", 1);
					}, 150 * index + 50);
				});
			}).catch(reason => {
				console.error("lazy thumbnails fetch failed", reason);
			}).then(() => {
				$btn.removeClass("disabled");
				$main.removeClass("busy");
			});
		});
	});
}
